






import {
    myVue
} from "@/components/class/myVue";
import {
    Component
} from 'vue-property-decorator';
@Component
export default class HelloWorld extends myVue {
    get srcList() {
        let list = []
        for (let i = 0; i < this.current.value.length; i++) {
            list.push('/api/' + this.current.value[i].url)
        }
        return list
    }
}
